/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NominalAccounts } from '../models/NominalAccounts';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControllingNominalAccountsService {
    /**
     * list nominal accounts
     * @param tenantId tenant_id
     * @param year year
     * @returns NominalAccounts successful
     * @throws ApiError
     */
    public static getNominalAccounts(
        tenantId: string,
        year: number,
    ): CancelablePromise<NominalAccounts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/nominal_accounts',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'year': year,
            },
        });
    }
}
